import React from "react"
import Rating from "@mui/material/Rating"
import connect from "./connect"
import {StarRatingWrapper} from "./components"

interface StarRatingContainerProps {
    overallStarRating: number
    colourwaysHasPriceRangeAndStarRatings?: boolean
    tooltipTitle: string
    ratingText: string
}

const wrapperClassNames = (overallStarRating, colourwaysHasPriceRange) => {
    let className = overallStarRating > 0 ? "" : "prod-summary-star-rating--hidden"
    className += !colourwaysHasPriceRange ? " showRatingInline" : ""

    return className
}

export const StarRatingContainer = ({
    overallStarRating,
    tooltipTitle,
    colourwaysHasPriceRangeAndStarRatings,
    ratingText,
}: StarRatingContainerProps) => (
    <StarRatingWrapper
        className={wrapperClassNames(overallStarRating, colourwaysHasPriceRangeAndStarRatings)}
        title={`${tooltipTitle} | ${overallStarRating} ${ratingText}`}
        data-testid={`product_summary_star-rating${overallStarRating > 0 ? "" : "--hidden"}`}
        tabIndex={-1}
    >
        <Rating value={overallStarRating} size="small" />
    </StarRatingWrapper>
)

export default connect(StarRatingContainer)
